/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * CarouselContext
 *
 * --- REWRITE SUMMARY ---
 * - LINTING FIX (react-refresh/only-export-components): The CarouselProvider
 * component has been moved to its own file (CarouselProvider.jsx). This file
 * now only exports non-component values (the context and a hook), which
 * satisfies the strict linting rule. The unused eslint-disable comment has
 * been removed.
 */
import { createContext, useContext } from 'react';

// 1. Create the context with a default value.
export const CarouselContext = createContext({
  targetSlide: null,
  setTargetSlide: () => {},
  carouselReadyState: {},
  setCarouselReady: () => {},
});

// 2. Create and export a custom hook for easy consumption.
export const useCarousel = () => useContext(CarouselContext);
